var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{attrs:{"id":"app"}},[_c('navBar'),_c('router-view',{class:_vm.responsiveMargin}),_c('notify')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }